<template>
  <div id="app" class="theme-default">
    <div id="nprogress-container" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AyvensStrator',
  mounted() {
    this.$el.parentElement.className = 'theme-default';
  }
};
</script>
